import { useLocation } from "react-router-dom";
import {
  useMantineTheme,
  Button,
  Tooltip,
  Box,
  Text,
  Group,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { MdContactSupport } from "react-icons/md";

function SupportLoader() {
  const location = useLocation();
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const showButton =
    location.pathname === "/inicio" || location.pathname === "/";

  if (!showButton) return null;

  const handleClick = () => {
    window.open("https://holaelsa.tawk.help/", "_blank");
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: isMobile ? 16 : 24,
        right: isMobile ? 16 : 24,
        zIndex: 1000,
      }}
    >
      <Button
        onClick={handleClick}
        radius="xl"
        color="genderlab-red.6"
        leftSection={<MdContactSupport size={20} />}
        style={{
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
      >
        ¿Necesitas ayuda?
      </Button>
    </div>
  );
}

export default SupportLoader;
